import { render, staticRenderFns } from "./BrandTrainingDetails.vue?vue&type=template&id=36a2e53b&scoped=true"
import script from "./BrandTrainingDetails.vue?vue&type=script&lang=js"
export * from "./BrandTrainingDetails.vue?vue&type=script&lang=js"
import style0 from "./BrandTrainingDetails.vue?vue&type=style&index=0&id=36a2e53b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a2e53b",
  null
  
)

export default component.exports